module.exports = "/_next/static/images/26707ac00f3954bdcd46adcbef631b88-app-avatar-4x.png.webp";